import { Component, ElementRef, inject, ViewChild } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { SidebarService } from '../sidebar/services/sidebar.service';
import { SvgIconComponent } from '../../shared/components/svg-icon/svg-icon.component';
import { LangService } from '../../shared/services/lang/lang.service';
import { Store } from '@ngrx/store';
import { toSignal } from '@angular/core/rxjs-interop';
import { UserActions } from 'src/app/shared/store/user/user.actions';
import { Router } from '@angular/router';
import { UserSelector } from 'src/app/shared/store/user/user.feature';
import { region } from 'src/environment/environment';

@Component({
  selector: 'app-header',
  imports: [MatMenuModule, SvgIconComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  private store = inject(Store);
  user = toSignal(this.store.select(UserSelector.selectUser));
  private router = inject(Router);
  private sidebarService = inject(SidebarService);
  private langService = inject(LangService);

  labels = this.langService.lang.core.header;
  private region = region;
  regionIcon = this.region.icon;

  // Solution for toggling-button-width dropdown menu adapted from
  // https://github.com/angular/components/issues/18532.
  // The width of the toggling button is queried dynamically and used to set
  // the width of the menu items.  This also requires unsetting max-width for
  // the mat-menu-panel class.
  @ViewChild('userMenuButton', { read: ElementRef })
  userMenuButton!: ElementRef<HTMLElement>;

  get userMenuButtonWidth(): number {
    return this.userMenuButton?.nativeElement?.clientWidth ?? 0;
  }

  openNav() {
    this.sidebarService.toggle();
  }

  logout() {
    this.store.dispatch(UserActions.logOut());
  }

  login() {
    this.store.dispatch(UserActions.authenticate());
  }

  navigateHome() {
    this.router.navigate(['/']);
  }

  menuOpen = true;
}
